import { CIcon } from '~/icons/types'
export const ciFax: CIcon = {
  width: 512,
  height: 504.6,
  paths: [
    {
      d:
        'M461.5 150.8h-40.3V66.2L355 0H131.3C109 0 90.8 18.2 90.8 40.5v110.3H50.5C22.7 150.8 0 173.5 0 201.3v179c0 27.8 22.7 50.5 50.5 50.5h40.3v33.3c0 22.3 18.2 40.5 40.5 40.5h249.3c22.3 0 40.5-18.2 40.5-40.5v-33.3h40.3c27.8 0 50.5-22.7 50.5-50.5v-179c.1-27.8-22.6-50.5-50.4-50.5zm-110.3-125L395.3 70h-38.9c-2.9 0-5.2-2.3-5.2-5.2v-39zM111.8 40.5c0-10.8 8.7-19.5 19.5-19.5h198.8v43.8c0 14.5 11.8 26.2 26.2 26.2h43.8v59.8H111.8V40.5zm288.4 423.6c0 10.8-8.7 19.5-19.5 19.5H131.3c-10.8 0-19.5-8.7-19.5-19.5V309.9h288.3v154.2zm90.8-83.8c0 16.3-13.2 29.5-29.5 29.5h-40.3V288.9H90.8v120.9H50.5c-16.3 0-29.5-13.2-29.5-29.5v-179c0-16.3 13.2-29.5 29.5-29.5h410.9c16.3 0 29.5 13.2 29.5 29.5v179z'
    },
    {
      d:
        'M158 359.8h196c5.8 0 10.5-4.7 10.5-10.5s-4.7-10.5-10.5-10.5H158c-5.8 0-10.5 4.7-10.5 10.5s4.7 10.5 10.5 10.5zm0 47.5h196c5.8 0 10.5-4.7 10.5-10.5s-4.7-10.5-10.5-10.5H158c-5.8 0-10.5 4.7-10.5 10.5s4.7 10.5 10.5 10.5zm0 47.5h126c5.8 0 10.5-4.7 10.5-10.5s-4.7-10.5-10.5-10.5H158c-5.8 0-10.5 4.7-10.5 10.5s4.7 10.5 10.5 10.5z'
    }
  ],
  name: 'fax',
  type: 'regular'
}
